import React from 'react';
import { Button, Tag } from 'antd';
import { getClassificationResult } from '../../../lib/util';
import { getTagStatus } from '../../../lib/util/status';
import { Inference } from '../../../types';
import { CustomLink } from '../../../components/CustomLink';

export const getTableClassificationColumns = (
  onClickUrl: (inference: Inference) => any,
  onDelete: (e: any, inference: Inference) => any
) => {
  return [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      render: (text: string, record: Inference) => (
        <span>
          <CustomLink disabled={record.status === 'PROCESSING'} onClickUrl={onClickUrl(record)}>
            {text}
          </CustomLink>
        </span>
      ),
    },
    {
      title: 'Class',
      key: 'id',
      dataIndex: 'id',
      render: (text: string, record: Inference) => (
        <span>
          <Tag>{getClassificationResult(record) || 'Unknown'}</Tag>
        </span>
      ),
    },
    {
      title: 'Status',
      key: 'id',
      dataIndex: 'id',
      render: (text: string, record: Inference) => <span>{getTagStatus(record.status)}</span>,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: Inference) => (
        <span>
          <Button type="link" style={{ fontSize: '14px' }} onClick={e => onDelete(e, record)}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
};
